export const API_PREFIX: string = "";
export const API_ACTION_PREFIX: string = API_PREFIX + "rpc/portal/action";
export const API_PROFILE_WEB_PREFIX: string = API_PREFIX + "rpc/portal/profile";

export const API_USER_NOTIFICATION_ROUTE: string =
  API_PREFIX + "rpc/utils/user-notification";
export const API_APP_USER_PREFIX: string = API_PREFIX + "rpc/portal/app-user";
export const API_APP_USER_PERMISSION_PREFIX: string =
  API_PREFIX + "rpc/portal/app-user-permission";
export const API_APP_USER_ROLE_MAPPING_PREFIX: string =
  API_PREFIX + "rpc/portal/app-user-role-mapping";
export const API_APP_USER_SESSION_PREFIX: string =
  API_PREFIX + "rpc/portal/app-user-session";
export const API_APP_USER_SITE_MAPPING_PREFIX: string =
  API_PREFIX + "rpc/portal/app-user-site-mapping";
export const API_LDAP_CONFIGURATION_PREFIX: string =
  API_PREFIX + "rpc/portal/ldap-configuration";
export const API_ORGANIZATION_PREFIX: string =
  API_PREFIX + "rpc/portal/organization";
export const API_PERMISSION_PREFIX: string =
  API_PREFIX + "rpc/portal/permission";
export const API_DOCUMENT_PERMISSION_PREFIX: string =
  API_PREFIX + "rpc/portal/document-permission";
export const API_PROJECT_DOCUMENT_FOLDER_PERMISSION_PREFIX: string =
  API_PREFIX + "rpc/construction/project-document-folder/folder-permission";
export const API_PERMISSION_FIELD_MAPPING_PREFIX: string =
  API_PREFIX + "rpc/portal/permission-field-mapping";
export const API_PERMISSION_OPERATOR_PREFIX: string =
  API_PREFIX + "rpc/portal/permission-operator";
export const API_PROVIDER_PREFIX: string = API_PREFIX + "rpc/portal/provider";
export const API_ROLE_PREFIX: string = API_PREFIX + "rpc/portal/role";
export const API_SITE_PREFIX: string = API_PREFIX + "rpc/portal/site";
export const API_THEME_PREFIX: string = API_PREFIX + "rpc/portal/theme";
export const API_DISTRICT_PREFIX: string = API_PREFIX + "rpc/portal/district";
export const API_PROVINCE_PREFIX: string = API_PREFIX + "rpc/portal/province";
export const API_WARD_PREFIX: string = API_PREFIX + "rpc/portal/ward";
export const API_NATION_PREFIX: string = API_PREFIX + "rpc/portal/nation";
export const API_USER_MANUAL_PREFIX: string =
  API_PREFIX + "rpc/portal/user-manual";
export const API_RESPONSIBILITY_PREFIX: string =
  API_PREFIX + "rpc/portal/responsibility";
export const API_WORKFLOW_DEFINITION_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-definition";
export const API_WORKFLOW_DIRECTION_CONDITION_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-direction-condition";
export const API_WORKFLOW_DIRECTION_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-direction";
export const API_WORKFLOW_OPERATOR_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-operator";
export const API_WORKFLOW_PARAMETER_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-parameter";
export const API_WORKFLOW_PARAMETER_TYPE_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-parameter-type";
export const API_WORKFLOW_STATE_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-state";
export const API_WORKFLOW_STEP_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-step";
export const API_WORKFLOW_TYPE_PREFIX: string =
  API_PREFIX + "rpc/portal/workflow-type";
export const API_INIT_PREFIX: string = API_PREFIX + "rpc/portal/init-data";
export const API_PROFILE_PREFIX: string = API_PREFIX + "rpc/portal/profile";
export const API_EXTERNAL_AUTHENTICATION_PREFIX: string =
  API_PREFIX + "rpc/portal/external-authentication";
export const API_LOGIN_CONFIGURATION_PREFIX: string =
  API_PREFIX + "rpc/portal/login-configuration";
export const API_APP_USER_GROUPING_PREFIX: string =
  API_PREFIX + "rpc/portal/app-user-grouping";
export const API_PROJECT_DOCUMENT_USER_GROUPING_PREFIX: string =
  API_PREFIX + "rpc/portal/project-document-user-grouping";
export const API_REGION_PREFIX: string = API_PREFIX + "rpc/portal/region";
export const API_POSITION_PREFIX: string = API_PREFIX + "rpc/portal/position";
export const API_FILE_TEMPLATE_PREFIX: string =
  API_PREFIX + "rpc/portal/file-template";
export const API_MENU_REPORT_PREFIX: string =
  API_PREFIX + "rpc/portal/menu-report";
export const API_LOGGING_API_PREFIX: string =
  API_PREFIX + "rpc/construction-sap/log-integration-api";

export const API_INTEGRATION_EAP_CONFIGURATION_PREFIX: string =
  API_PREFIX + "rpc/portal/menu";

export const API_PROJECT_AUTHORIZATION_REPORT_PREFIX: string =
  API_PREFIX + "rpc/portal/project-authorization-report";

export const API_EMAIL_REMINDER_CONFIG_PREFIX: string =
  API_PREFIX + "rpc/portal/email-reminder-config";
